import React, { useState }  from "react";
import '../App.scss';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useUserContext } from "./UserContext";
import logo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { changePassword } from "./WorkerService";

const Login: React.FC = (props) => {

    const navigate = useNavigate();
    const userContext = useUserContext();
    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [validated, setValidated] = useState(false);
    const [forgotPassword, setForgotPassword] = useState(false);
    const [resetSent, setResetSent] = useState(false);
    const [confirmationCode, setConfirmationCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [buttonText, setButtonText] = useState("Submit");
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const [isChangingPassword, setIsChangingPassword] = useState(false);
    
    const handleSubmit = async (event: any) => {
        event.preventDefault();

        var { username, password } = document.forms[0];

        setUserName(username.value.trim());
        setPassword(password.value.trim());
        setIsLoggingIn(true);

        if(username.value.trim().length === 0 || password.value.trim().length === 0)
        {
            setValidated(true);
            setIsLoggingIn(false);
            return;
        }

        try {
            const result = await userContext.login(username.value!, password.value!);
            if (result.success) {
                navigate({ pathname: "/" }, {replace: true});
            } else {
                setIsLoggingIn(false);

                if(result.message === "NewPasswordRequired"){
                    setIsChangingPassword(true);
                } else {
                    alert(result.message);
                }
            }
        } catch (error: any) {
            setIsLoggingIn(false);
            alert(`ERROR: Login\n ${error.message}`);
        }
    };

    // const handleChangePassword = async () => {
    //     try {
    //         const result = await userContext.changePassword(password, newPassword, confirmPassword);
    //         if (result.success) {
    //             alert("Password changed successfully.");
    //         } else {
    //             alert(`ERROR: ChangePassword - ${result.message}`);
    //         }
    //     } catch (error: any) {
    //         alert(`ERROR: ChangePassword\n ${error.message}`);
    //     }
    // };

    const checkPassword = () => {
        if(newPassword.trim().length === 0 || 
            confirmPassword.trim().length === 0){
            throw new Error("Password required")
        }
        
        if(newPassword !== confirmPassword){
            throw new Error("Passwords do not match");
        }
    }

    const handleOnChangeEmail = (e: any) => {
        const value = e.currentTarget.value;
        setEmail(value);
    };

    const handleOnChangeCode = (e: any) => {
        const value = e.currentTarget.value;
        setConfirmationCode(value);
    };

    const handleOnChangeNewPassword = (e: any) => {
        const value = e.currentTarget.value;
        setNewPassword(value);
    };

    const handleOnChangeConfirmPassword = (e: any) => {
        const value = e.currentTarget.value;
        setConfirmPassword(value);
    };
    
    const handleForgotPassword = async (event: any) => {
        event.preventDefault();

        setEmail(email.trim());
        // setValidated(true);

        if(email.trim().length === 0){
            return;
        }

        try {
            // Account action response
            // 0 - Unknown	
            // 1 - TemporaryPasswordSent --> new temp password sent	
            // 2 - VerificationLinkSent	
            // 3 - ForgottenPasswordSent --> verification code sent to email
            const result = await userContext.forgotPassword(email!);
            if (result) {

                if(result.AccountAction === 1){
                    alert("Temporary password sent to your email.");
                    window.location.href = "/login";
                    return;
                } else if (result.AccountAction === 3){
                    setConfirmationCode("");
                    setNewPassword("");
                    setConfirmPassword("");
                    
                    setResetSent(true);
                    setValidated(false);

                    alert("Verification code sent to your email.");
                } else {
                    alert("AccountAction = " + result.AccountAction);
                }
            } else {
                alert("Failed to process Forgot Password.");
            }
        } catch (error: any) {
            alert(`ERROR: Reset Password\n ${error.message}`);
        }
    };

    const handleChangeForgotPassword = async (event: any) => {
        event.preventDefault();

        if(isChangingPassword){
            handleChangeTempToUserPassword();
            return;
        }

        setConfirmationCode((confirmationCode) => confirmationCode.trim())
        setNewPassword((newPassword) => newPassword.trim());
        setConfirmPassword((confirmPassword) => confirmPassword.trim());
        setValidated(true);

        try {
            checkPassword();

            if(confirmationCode.trim().length === 0 ){
                throw new Error("Verification code required");
            }

            setButtonText("Processing...")

            const result = await userContext.changeForgotPassword(email, newPassword, confirmPassword, confirmationCode!);
            if (result) {
                alert("Password reset successfully.");
                window.location.href = "/login";
            } else {
                alert("ERROR: Failed to reset password.");
            }
        } catch (error: any) {
            alert(`ERROR: ChangeForgotPassword\n ${error.message}`);
        }
        setButtonText("Submit");
    };

    const handleChangeTempToUserPassword = async () => {
        
        try {
            checkPassword();
            
            const result = await userContext.changeTempToUserPassword(userName, password, newPassword, confirmPassword);
            if (result.success) {
                alert("Password changed successfully.");
                window.location.href = "/login";
            } else {
                if(result.message === "InvalidPasswordException") {
                    const msg = "Password does not meet the requirements:\n\n" + 
                    "Must be at least 8 characters long\n" + 
                    "Must contain at least 1 number\n" + 
                    "Must contain at least 1 uppercase letter\n" + 
                    "Must contain at least 1 lowercase letter\n";

                    alert(msg);
                }
                else{
                    alert(`ERROR: Changing temporary password\n ${result.message}`);
                }
            }
        } catch (error: any) {
            alert(`ERROR: Changing temporary password\n ${error.message}`);
        }
    };

    return (
        <>
            <div className="login-form">
                <div style={{textAlign:"center"}}>
                    <img src ={logo} alt="Logo here" width="100%"/>
                </div>
                {!resetSent && !isChangingPassword &&
                    <Form onSubmit={handleSubmit} className="d-flex flex-column">
                        <Form.Label className="mt-3 mb-1">Username</Form.Label>
                        <Form.Control type="text" name="username" required />

                        <Form.Label className="mt-3 mb-1">Password</Form.Label>
                        <Form.Control type="password" name="password" required />

                        <Button variant="success" type="submit" >
                            Log In
                        </Button>   

                        <div className="forgot-password mt-3 text-center">
                            <label style={{cursor:"pointer"}} onClick={() => setForgotPassword(!forgotPassword) }>Forgot password?</label>
                        </div>

                    </Form>
                }

                {forgotPassword && !resetSent &&
                    <>
                        <div style={{borderBottom:"1px solid darkgray", marginTop:"20px"}}></div>
                        <Form onSubmit={handleForgotPassword}>
                            <div className="form-group mt-3">
                                <label>Email</label>
                                <input
                                    type="email"
                                    className="form-control mt-1"
                                    required
                                    // placeholder="Enter email address"
                                    value={email}
                                    onChange={e => handleOnChangeEmail(e)}
                                />
                            </div>
                            <div className="d-grid gap-2 mt-2">
                                <Button type="submit" variant="success" disabled={false}>Reset</Button>
                            </div>
                        </Form>
                    </>
                }

                {((forgotPassword && resetSent) || isChangingPassword) &&
                    <div>
                        <Form onSubmit={handleChangeForgotPassword}>
                            <div style={{borderBottom:"1px solid darkgray", marginTop:"20px"}}></div>
                            {isChangingPassword &&
                                <label style={{fontWeight:"lighter"}}>Enter your new password</label>
                            }
                            <div className="form-group mt-3">
                                {!isChangingPassword &&
                                    <>
                                        <label>Verification Code</label>
                                        <input
                                            type="text"
                                            className="form-control mb-1"
                                            value={confirmationCode}
                                            onChange={e => handleOnChangeCode(e)}
                                            required
                                        />
                                    </>
                                }
                                <label className="mt-2">New Password</label>
                                <input
                                    type="password"
                                    className="form-control mb-1"
                                    value={newPassword}
                                    onChange={e => handleOnChangeNewPassword(e)}
                                    required
                                />
                                <label>Confirm Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={confirmPassword}
                                    onChange={e => handleOnChangeConfirmPassword(e)}
                                    required
                                />
                            </div>
                            <div className="text-center">
                                <Button type="submit" variant="success" disabled={false} >
                                    {buttonText}
                                </Button>
                            </div>
                        </Form>
                    </div>
                }
            </div>
        </>

    );
}

export default Login;